import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

import * as Sentry from '@sentry/angular'; // Recommended to import as Sentry
import * as projectJson from '../package.json';
import * as dsn_env from '../environments/env.local.json';

// 1. Initialize Sentry FIRST
Sentry.init({
  dsn: dsn_env.GT_DSN_INTERVIEWER_PORTAL,
  environment: dsn_env.env_name,
  release: projectJson.version,
  tracesSampleRate: 0.01,
  integrations: [
    // This handles the session tracking in newer SDK versions
    Sentry.browserSessionIntegration(),
    Sentry.browserTracingIntegration(),
  ],
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
